import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-white shadow-md'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center">
            <img
              src="https://static.readdy.ai/image/adbcdcc03ccb95572cdcd393dd2136c2/b63b494060a1aedc289e5e86c85f786b.jpeg"
              alt="Eu Lidero"
              className="h-12 w-auto"
            />
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled || !isHome
                  ? 'text-gray-700 hover:text-purple-600'
                  : 'text-white hover:text-gold-400'
              }`}
            >
              Início
            </Link>
            <a
              href="/#programa"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled || !isHome
                  ? 'text-gray-700 hover:text-purple-600'
                  : 'text-white hover:text-gold-400'
              }`}
            >
              O Programa
            </a>
            <Link
              to="/modulos"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled || !isHome
                  ? 'text-gray-700 hover:text-purple-600'
                  : 'text-white hover:text-gold-400'
              }`}
            >
              Módulos
            </Link>
            <Link
              to="/especialistas"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled || !isHome
                  ? 'text-gray-700 hover:text-purple-600'
                  : 'text-white hover:text-gold-400'
              }`}
            >
              Especialistas
            </Link>
            <Link
              to="/investimento"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled || !isHome
                  ? 'text-gray-700 hover:text-purple-600'
                  : 'text-white hover:text-gold-400'
              }`}
            >
              Investimento
            </Link>
          </div>

          <Link
            to="/inscricao"
            className="bg-gold-500 text-purple-900 px-6 py-3 rounded-full text-sm font-semibold hover:bg-gold-400 transition-all hover:scale-105 shadow-lg whitespace-nowrap"
          >
            Quero me inscrever
          </Link>
        </div>
      </div>
    </nav>
  );
}
